var vars = require('./core');

module.exports = vars.createClass('Bar', ['getBarsAtEvent']);



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-chartjs/lib/bar.js
 ** module id = 491
 ** module chunks = 0
 **/